import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";

import completeLogin, { pendingClassId } from "lib/session";

import JoiningBanner from "features/auth/JoiningBanner";
import Button from "components/ui/Button";

// Figma 4:2360: label 14/20 semibold, 38px inputs with a #E2E2E2 border,
// eye toggle on the password, full-width blue button, links underneath.
function EyeIcon({ open }) {
  return (
    <svg width="18" height="16" viewBox="0 0 24 20" aria-hidden="true">
      <path d="M1.5 10S5.5 3 12 3s10.5 7 10.5 7-4 7-10.5 7S1.5 10 1.5 10z" fill="none" stroke="#626b79" strokeWidth="1.8" />
      <circle cx="12" cy="10" r="3.2" fill="none" stroke="#626b79" strokeWidth="1.8" />
      {!open && <path d="M4 18L20 2" stroke="#626b79" strokeWidth="1.8" strokeLinecap="round" />}
    </svg>
  );
}

function LoginForm({ history }) {
  const dispatch = useDispatch();
  const [Form, setForm] = useState({ email: "", password: "" });
  const [Show, setShow] = useState(false);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const classId = pendingClassId();

  // Read the event now: React 16 pools events, so e.target is null by the
  // time a functional state update runs.
  const set = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  function submit(e) {
    e.preventDefault();
    setError(null);
    setIsSubmitting(true);

    completeLogin({ email: Form.email.trim(), password: Form.password }, dispatch)
      .then((next) => history.push(next))
      .catch((err) => {
        setIsSubmitting(false);
        // One message for unknown email and wrong password: friendlier, and
        // it doesn't reveal which emails have accounts.
        const status = err?.response?.status;
        setError(
          status === 400 || status === 401 || status === 404
            ? "Email or password is incorrect."
            : status === 429
            ? err.response.data.message
            : "Could not log in right now. Please try again."
        );
      });
  }

  return (
    <form onSubmit={submit} noValidate className="yc-auth-form">
      {classId && <JoiningBanner classId={classId} action="Log in" />}
      {error && (
        <p className="yc-alert is-error" role="alert">
          {error}
        </p>
      )}
      <div className="yc-auth-field">
        <label htmlFor="login-email">Email (required)</label>
        <input id="login-email" name="email" type="email" value={Form.email} onChange={set} autoComplete="email" required />
      </div>
      <div className="yc-auth-field yc-auth-field--last">
        <label htmlFor="login-password">Password</label>
        <div className="yc-auth-pass">
          <input
            id="login-password"
            name="password"
            type={Show ? "text" : "password"}
            value={Form.password}
            onChange={set}
            autoComplete="current-password"
            required
          />
          <button type="button" className="yc-auth-eye" onClick={() => setShow((s) => !s)} aria-label={Show ? "Hide password" : "Show password"} aria-pressed={Show}>
            <EyeIcon open={Show} />
          </button>
        </div>
      </div>
      <Button type="submit" block size="lg" disabled={isSubmitting}>
        {isSubmitting ? "Logging in…" : "Log In"}
      </Button>
      <p className="yc-auth-aside">
        <span>New to Youwdin Class?</span>
        <span className="yc-auth-dot" aria-hidden="true" />
        <Link to="/register">Create account</Link>
      </p>
    </form>
  );
}

export default withRouter(LoginForm);
